import {
  Box,
  Button,
  Divider,
  FormControl,
  FormLabel,
  Input,
  Text,
  useToast,
} from '@chakra-ui/react';
import firebase from 'firebase/app';
import React, { useState } from 'react';
import { useForm } from 'react-hook-form';
import Lottie from 'react-lottie';
import { useHistory } from 'react-router-dom';
import animationData from '../../../assets/animations/lifter.json';
import { BackgroundImage } from '../../../components/BackgroundImage';
import { Card } from '../../../components/Card';
import { AuthContainer } from '../../../components/container/AuthContainer';
import { PageContainer } from '../../../components/container/PageContainer';
import { BackToLoginButton } from '../../../components/styled-chakra/BackToLoginButton';
import { useConfig } from '../../../hooks/useConfig';

interface FormData {
  email: string;
}

export const ForgetPasswordPage: React.FC = () => {
  const [loading, setLoading] = useState(false);
  const { register, handleSubmit, formState } = useForm<FormData>();
  const { errors } = formState;
  const history = useHistory();
  const toast = useToast();
  const firebaseConfig = useConfig();

  const onSubmit = handleSubmit(({ email }) => {
    setLoading(true);
    firebase
      .auth()
      .sendPasswordResetEmail(email)
      .then(() => {
        setLoading(false);
        toast({
          title: 'E-Mail gesendet.',
          description: `Wir haben dir eine Email zum Zurücksetzen an ${email} gesendet.`,
          status: 'success',
          duration: 9000,
          isClosable: true,
        });
        history.push('/login');
      })
      .catch((e) => {
        if (e.code === 'auth/user-not-found') {
          toast({
            title: 'Deine E-Mail wurde nicht gefunden.',
            status: 'error',
            duration: 9000,
            isClosable: true,
          });
        }
        setLoading(false);
      });
  });

  return (
    <PageContainer center>
      <AuthContainer
        title="Next level online-fitness"
        subtitle={`in deinem ${firebaseConfig?.displayName}`}
        icon={
          <Lottie
            isClickToPauseDisabled={true}
            options={{
              loop: true,
              autoplay: true,
              animationData,
              rendererSettings: {
                preserveAspectRatio: 'xMidYMid slice',
              },
            }}
            style={{ width: '33%', height: 'auto' }}
          />
        }
      >
        <Card title="Passwort vergessen">
          <Box textAlign="left">
            <Text mb={2}>
              Es tut uns sehr leid, dass du dein Passwort vergessen hast.
            </Text>
            <Text mb={4}>
              Du kannst dir hier eine E-Mail senden lassen, in welcher du dein
              Passwort zurücksetzen kannst.
            </Text>
            <form onSubmit={onSubmit}>
              <FormControl isRequired={true} isInvalid={!!errors.email}>
                <FormLabel>E-Mail</FormLabel>
                <Input
                  type="email"
                  placeholder="jemand@jemand.de"
                  {...register('email', { required: true })}
                />
              </FormControl>
              <Button
                colorScheme="brand"
                width="full"
                mt={4}
                type="submit"
                isLoading={loading}
              >
                Passwort zurücksetzen
              </Button>
            </form>
            <Divider py={3} />
            <BackToLoginButton />
          </Box>
        </Card>
        <BackgroundImage />
      </AuthContainer>
    </PageContainer>
  );
};
